function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-disabled_svg__a",
  d: "M19.739 18.325L5.676 4.262A9.944 9.944 0 0112 2c5.514 0 10 4.486 10 10 0 2.398-.85 4.6-2.261 6.325M1.999 12c0-2.398.85-4.6 2.262-6.324l14.064 14.063A9.954 9.954 0 0112 22C6.486 22 2 17.514 2 12M12 0C5.383 0 0 5.384 0 12c0 6.617 5.383 12 12 12s12-5.383 12-12c0-6.616-5.383-12-12-12"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-disabled_svg__a"
});

var SvgIconDisabled = function SvgIconDisabled(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconDisabled;